import { Injectable } from '@angular/core';
import { CartUpdateEntrySuccessEvent } from '@spartacus/cart/base/root';
import { createFrom, EventService } from '@spartacus/core';
import { map } from 'rxjs/operators';
import { GtmGgCartUpdateEntrySuccessEvent } from './gtm-gg-cart-update-entry-success-event';

@Injectable({
  providedIn: 'root',
})
export class GtmGgCartUpdateEntrySuccessEventBuilder {
  constructor(private eventService: EventService) {
    const gtmGgCartUpdateEntrySuccessEventSource = this.eventService.get(CartUpdateEntrySuccessEvent).pipe(
      map((successfullyEditedEntry) =>
        createFrom(GtmGgCartUpdateEntrySuccessEvent, {
          event:
            successfullyEditedEntry.entry.quantity && successfullyEditedEntry.quantity
              ? successfullyEditedEntry.entry.quantity > successfullyEditedEntry.quantity
                ? 'remove-from-cart'
                : 'add-to-cart'
              : '',
          productId: successfullyEditedEntry.entry.product?.code ? successfullyEditedEntry.entry.product.code : '',
          ecommerce: {
            currencyCode: successfullyEditedEntry.entry.product?.price?.currencyIso
              ? successfullyEditedEntry.entry.product.price.currencyIso
              : '',
            remove: {
              products: [
                {
                  name: successfullyEditedEntry.entry.product?.name ? successfullyEditedEntry.entry.product.name : '',
                  id: successfullyEditedEntry.entry.product?.code ? successfullyEditedEntry.entry.product.code : '',
                  price: successfullyEditedEntry.entry.product?.price?.value
                    ? successfullyEditedEntry.entry.product.price.value
                    : '',
                  quantity:
                    successfullyEditedEntry.entry.quantity && successfullyEditedEntry.quantity
                      ? successfullyEditedEntry.entry.quantity > successfullyEditedEntry.quantity
                        ? successfullyEditedEntry.entry.quantity - successfullyEditedEntry.quantity
                        : successfullyEditedEntry.quantity - successfullyEditedEntry.entry.quantity
                      : '',
                },
              ],
            },
          },
        })
      )
    );

    eventService.register(GtmGgCartUpdateEntrySuccessEvent, gtmGgCartUpdateEntrySuccessEventSource);
  }
}
